import React, { useEffect, useMemo, useRef } from 'react';
import * as EmbedComponents from './EmbedSources';

import './style.scss';

const SOURCE_YOUTUBE = 'Youtube';
const SOURCE_RUTUBE = 'Rutube';
const SOURCE_VK = 'Vk';

const avaliableSources = [SOURCE_YOUTUBE, SOURCE_RUTUBE, SOURCE_VK];

const VideoEmbedModal = ({embedLink}) => {
    const iframeRef = useRef(null);
    const EmbedPlayer = useMemo(() => {
        const videoUrl = new URL(embedLink);
        const source = avaliableSources.find((source) => videoUrl.hostname.includes(source.toLowerCase()));

        return EmbedComponents?.[`Embed${source}`] ?? null;
    });

    useEffect(() => {
        if (!iframeRef.current) return;

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [iframeRef]);

    function handleResize() {
        if (window.innerWidth > 980) {
            return;
        }
        
        iframeRef.current.setAttribute('width', window.innerWidth - 80);
        iframeRef.current.setAttribute('height', Math.round((window.innerWidth - 80) * 0.56));
    }

    if (!EmbedPlayer) {
        return <></>;
    }

    return (
        <div className="video-embed-modal">
            <EmbedPlayer
                iframeRef={iframeRef}
                link={embedLink}
            />
        </div>
    )
};

export default VideoEmbedModal;
